<template>
  <material-card color="orange" title="Audit Trail">
    <v-data-table class="audit_trail_table" style="width: 100%" fixed-header small density="compact" :loading="loading"
      hide-default-footer hide-default-header hide-footer :items-per-page='-1' :headers="headers" :items="filteredItems"
      :item-class="itemStyle">
      <template slot="header">
        <thead class='v-data-table-header'>
          <tr>
            <th :style="{ width: `${header.width}px` }" :key="header.value" v-for="header in headers" :class="`text-${header.align || 'left'}`">
              <span class="text--lighten-4">
                {{ header.text }}
              </span>
            </th>
          </tr>
          <tr>
            <th v-for="header in headers" :key="header.value" :class="`text-${header.align || 'left'}`">
              <v-text-field v-if="['account', 'field_name'].includes(header.value)" placeholder="Search"
                autocomplete="off" clearable density="compact" hide-details variant="underlined" color="success"
                v-model="localFilters[header.value]" />

              <template v-if="header.value === 'datetime'">
                <input type="date" v-model="localFilters.start_date" />
                <input type="date" v-model="localFilters.end_date" />
              </template>
              <br>
            </th>
          </tr>
        </thead>
      </template>
    </v-data-table>
  </material-card>
</template>

<script>
import { getList } from '../../api/base_entity'
import $format from '../../utils/formatter'
export default {
  props: {
    entity: String,
    entity_id: [String, Number],
    fields: Array,
    filters: Object,
    hideFields: [Array, Object]
  },
  data() {
    return {
      localFilters: { field_name: '', value: '', prev_value: '', account: '', start_date: '', end_date: '' },
      items: [],
      odd: false,
      opened: false,
      loading: false,
      headers: [
        { value: 'action', text: 'Action', width: 120 },
        { value: 'field_name', text: 'Name', width: 150 },
        { value: 'prev_value', text: 'Before', width: 150 },
        { value: 'value', text: 'After', width: 150 },
        { value: 'account', text: 'Account', width: 170, align: 'right' },
        { value: 'datetime', text: 'Date Time', width: 150, align: 'right' },
      ]
    }
  },
  mounted() {
    this._getData()
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {

        // field name
        if (this.localFilters.field_name && !i?.field_name?.toLocaleLowerCase().includes(this.localFilters.field_name.toLocaleLowerCase())) {
          return false
        }

        // account 
        if (this.localFilters.account && !i?.account?.toLocaleLowerCase().includes(this.localFilters.account.toLocaleLowerCase())) {
          return false
        }

        if (this.localFilters.start_date && i.datetime < this.localFilters.start_date) {
          return false
        }

        if (this.localFilters.end_date && i.datetime > this.localFilters.end_date) {
          return false
        }

        return i
      })
    }
  },
  methods: {
    itemStyle(item) {
      return item.odd ? 'odd' : ''
    },
    _getFieldLabel(field_name) {
      const field = this?.fields?.find(f => f.value === field_name)
      return field?.text ?? $format('field_name', field_name)
    },
    async _getData() {
      let res
      this.loading = true
      if (this.entity_id) {
        res = await getList(`audittrail/${this.entity}/${this.entity_id}`)
      } else {
        res = await getList(`audittrail/${this.entity}`, { filters: this.filters })
      }
      this.items = []
      for (const e of res.data) {
        this.items = this.items.concat(this._getChanges(e))
      }
      this.loading = false
    },
    _getChanges(entry) {

      const ignore_fields = ['id', 'restore_pass_token', 'insert_at', 'password']
      let changes = []
      for (const field_name in entry.fields) {

        if (ignore_fields.includes(field_name)) { continue }

        if (this.hideFields && this.hideFields[entry.entity] && this.hideFields[entry.entity].includes(field_name)) {
          continue
        }

        let value
        let prev_value

        // se il campo e' una foreign
        if (entry.foreigns_map[field_name]) {
          value = $format(entry.foreigns_map[field_name], entry.foreigns[entry.foreigns_map[field_name]], 'audit_trail')
          prev_value = $format(entry.foreigns_map[field_name], entry.prev_foreigns[entry.foreigns_map[field_name]], 'audit_trail')
        } else {
          value = $format(field_name, entry.fields[field_name], field_name, 'audit_trail')
          prev_value = $format(field_name, entry.prev_fields[field_name], field_name, 'audit_trail')
        }

        // se e' un PUT metto solo i valori nuovi
        const isEdit = entry.http_verb === 'PUT' // || ['Confirm', 'Request', 'Validate', 'Save New Pdf'].includes(entry.action)

        if (Array.isArray(value) && Array.isArray(prev_value)) {
          const equal = value.length === prev_value.length && value.every((value, index) => value === prev_value[index])
          if (equal) continue
        }
        if (value === prev_value && isEdit) continue

        // non lo metto se entrambi i valori sono vuoti
        if (!value && !prev_value) continue

        const re = new RegExp(this.entity, 'gi')
        changes.push({
          action: `${entry.action} ${entry.section}`.replace(re, ''), // entry.http_verb,
          account: entry.insert_by,
          odd: this.odd,
          datetime: entry.insert_at,
          field_name: this._getFieldLabel(field_name),
          prev_value,
          color: entry.color,
          foreign: entry.entity !== this.entity,
          value
        })
      }

      if (entry.http_verb === 'PUT' && !changes.length) {
        changes.push({
          action: entry.action,
          account: entry.insert_by,
          datetime: (entry.insert_at),
          color: entry.color,
          odd: this.odd,
          field_name: 'EMPTY UPDATE'
        })
      }

      if (changes.length) {
        this.odd = !this.odd
      }
      return changes
    }
  }
}

</script>
<style>
.odd {
  background-color: beige;
}

.audit_trail_table .v-data-table__wrapper {
  overflow-y: scroll;
  height: min(700px, 70vh);
}

.audit_trail_table td {
  word-wrap: anywhere;
}
</style>